import { createSelector } from 'reselect';

const getCreditReview = ({ creditReview }) => creditReview;

export const getCofaceRequestsAllowed = createSelector(
  getCreditReview,
  ({ cofaceRequestsAllowed }) => cofaceRequestsAllowed,
);

export const getCofaceTotalAmount = createSelector(
  getCreditReview,
  ({ cofaceTotalAmount }) => cofaceTotalAmount,
);
